
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cat/[brand]/[category]",
      function () {
        return require("private-next-pages/cat/[brand]/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cat/[brand]/[category]"])
      });
    }
  